<template>
  <div>
    <div class="request_changesec" v-if="!serviceRequest">
      <div class="row d-flex justify-content-center align-items-center">
        <div class="col-12">
          <div class="compose_mailsec">
            <app-profile
              :ticketFilter="ticketReasonList[loadServiceRequest]"
              :ticketRequest="ticketRequestFrom"
              :accountIdFrom="account_id"
            ></app-profile>
          </div>
        </div>
      </div>
    </div>
    <div class="main_inner_section services_request" v-else>
      <div
        class="support_search row align-items-center justify-content-center mb-0 pt-2 mb-md-5"
      >
        <!-- <div class="col-12 mb-md-5">
                    <h3>Opened Support Tickets</h3>
                    <p>Capital Wallet always here to help you with your unsettled issues </p>
                </div> -->
        <div class="col-12 col-md-6 section_title m-0 text-center">
          <h5 class="support_title my-4">How Can We Help You Today?</h5>
          <!-- <p>Please write to us with your queries. Our team will get in touch with you</p> -->
          <div
            class="supportTanb_btn d-flex justify-content-center align-items-center"
          >
            <a href="javascript:void(0)" class="links cap_btn active"
              >Support</a
            >
            <a href="javascript:void(0)" class="links">Request New Ticket</a>
          </div>
        </div>
      </div>
      <!-- <div class="row mb-5" v-if="ticketReasonList != ''">
                <div class="col-12 col-md-3">
                    <div class="staticSupport">
                        <div class="icon listWith">
                            <img src="'../../../../static/website/images/sr_profile.svg" alt="Icon">
                        </div>  
                        <h3>Profile</h3>
                        <ul class="listngSport">
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Professional Account Request</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Change Client Portal Password
                            </a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Account Verification Individual</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Enable 2fa</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Disable 2fa
                            </a></li>
                        </ul>
                        <div class="viewMoew">
                            <a class="d-flex align-items-center" href="#">View More <feather size="16px" type="chevron-right"></feather></a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <div class="staticSupport">
                        <div class="icon listWith">
                            <img src="'../../../../static/website/images/sr_profile.svg" alt="Icon">
                        </div>  
                        <h3>Profile</h3>
                        <ul class="listngSport">
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Professional Account Request</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Change Client Portal Password
                            </a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Account Verification Individual</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Enable 2fa</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Disable 2fa
                            </a></li>
                        </ul>
                        <div class="viewMoew">
                            <a class="d-flex align-items-center" href="#">View More <feather size="16px" type="chevron-right"></feather></a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <div class="staticSupport">
                        <div class="icon listWith">
                            <img src="'../../../../static/website/images/sr_profile.svg" alt="Icon">
                        </div>  
                        <h3>Profile</h3>
                        <ul class="listngSport">
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Professional Account Request</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Change Client Portal Password
                            </a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Account Verification Individual</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Enable 2fa</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Disable 2fa
                            </a></li>
                        </ul>
                        <div class="viewMoew">
                            <a class="d-flex align-items-center" href="#">View More <feather size="16px" type="chevron-right"></feather></a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <div class="staticSupport">
                        <div class="icon listWith">
                            <img src="'../../../../static/website/images/sr_profile.svg" alt="Icon">
                        </div>  
                        <h3>Profile</h3>
                        <ul class="listngSport">
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Professional Account Request</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Change Client Portal Password
                            </a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Account Verification Individual</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Enable 2fa</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Disable 2fa
                            </a></li>
                        </ul>
                        <div class="viewMoew">
                            <a class="d-flex align-items-center" href="#">View More <feather size="16px" type="chevron-right"></feather></a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <div class="staticSupport">
                        <div class="icon listWith">
                            <img src="'../../../../static/website/images/sr_profile.svg" alt="Icon">
                        </div>  
                        <h3>Profile</h3>
                        <ul class="listngSport">
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Professional Account Request</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Change Client Portal Password
                            </a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Account Verification Individual</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Enable 2fa</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Disable 2fa
                            </a></li>
                        </ul>
                        <div class="viewMoew">
                            <a class="d-flex align-items-center" href="#">View More <feather size="16px" type="chevron-right"></feather></a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <div class="staticSupport">
                        <div class="icon listWith">
                            <img src="'../../../../static/website/images/sr_profile.svg" alt="Icon">
                        </div>  
                        <h3>Profile</h3>
                        <ul class="listngSport">
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Professional Account Request</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Change Client Portal Password
                            </a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Account Verification Individual</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Enable 2fa</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Disable 2fa
                            </a></li>
                        </ul>
                        <div class="viewMoew">
                            <a class="d-flex align-items-center" href="#">View More <feather size="16px" type="chevron-right"></feather></a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <div class="staticSupport">
                        <div class="icon listWith">
                            <img src="'../../../../static/website/images/sr_profile.svg" alt="Icon">
                        </div>  
                        <h3>Profile</h3>
                        <ul class="listngSport">
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Professional Account Request</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Change Client Portal Password
                            </a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Account Verification Individual</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Enable 2fa</a></li>
                            <li><a href="#"><feather size="16px" type="chevron-right"></feather> Disable 2fa
                            </a></li>
                        </ul>
                        <div class="viewMoew">
                            <a class="d-flex align-items-center" href="#">View More <feather size="16px" type="chevron-right"></feather></a>
                        </div>
                    </div>
                </div>
            </div> -->
      <div class="row justify-content-center">
        <div class="col-12 maxCustom">
          <div class="form-group field-wrapper">
            <input
              type="text"
              class="form-control lightgrayBG"
              id="myInput"
              name=""
              placeholder="Search Here"
              v-on:keyup="keymonitor"
            />
            <a href="javascript:void(0)" class="searchIcon"
              ><feather type="search"></feather
            ></a>
          </div>
        </div>
        <div class="col-12 col-md-6 border-right">
          <div class="verifyAcc">
            <h5 class="medium mb-4">Top Questions</h5>
            <ul class="topQuestion">
              <li>
                <a href="javascript:void(0)"
                  >What documents are needed to verify my account?</a
                >
              </li>
              <li>
                <a href="javascript:void(0)"
                  >Where can I change my phone number?</a
                >
              </li>
              <li>
                <a href="javascript:void(0)"
                  >How do I disable the two-factor authentication?
                </a>
              </li>
              <li>
                <a href="javascript:void(0)"
                  >Where can I change my phone number?</a
                >
              </li>
            </ul>
            <router-link to="/help-topic" class="cap_btn lg mt-4"
              >Browse Help Topics
            </router-link>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="accessSystem">
            <div class="d-flex align-items-center justify-content-between">
              <h5 class="medium mb-4">Tickets</h5>
              <div
                class="form-group position-relative includeIco searchTable mb-0"
              >
                <input
                  type="text"
                  placeholder="Search all Cryptos"
                  name="legal_name"
                  class="form-control small"
                />
                <span class="searchIco"
                  ><feather type="search"></feather>
                </span>
              </div>
            </div>
            <ul class="d-flex align-items-center tabTickets my-4">
              <li>
                <a
                  class="nav-link medium"
                  @click.prevent="ticketsTab = 'open'"
                  :class="ticketsTab == 'open' ? 'active' : ''"
                  href="javascript:void(0)"
                  >Open</a
                >
              </li>
              <li>
                <a
                  class="nav-link medium"
                  @click.prevent="ticketsTab = 'closed'"
                  :class="ticketsTab == 'closed' ? 'active' : ''"
                  href="javascript:void(0)"
                  >Closed</a
                >
              </li>
            </ul>
            <div class="openTabs" v-if="ticketsTab == 'open'">
              <div
                class="listsys mb-3 d-flex justify-content-between align-items-start"
              >
                <div class="ltr">
                  <p class="themecolor medium">
                    Cannot access the system
                    <sup class="status yellowBG f-10 p-1">New</sup>
                  </p>
                  <div class="d-flex align-items-center">
                    <span class="smallbtn redBG mr-3">Urgent</span>
                    <span class="border_btn smallbtn themecolor">#CW225</span>
                  </div>
                </div>
                <p class="mb-0">1h ago</p>
              </div>
              <div
                class="listsys mb-3 d-flex justify-content-between align-items-start"
              >
                <div class="ltr">
                  <p class="themecolor medium">Cancel my order</p>
                  <div class="d-flex align-items-center">
                    <span class="smallbtn yellowBG mr-3">Medium</span>
                    <span class="border_btn smallbtn themecolor mr-3"
                      >#CW225</span
                    >
                    <span class="messageChat d-flex align-items-center"
                      ><feather
                        class="mr-1"
                        size="18px"
                        type="message-circle"
                      ></feather>
                      2</span
                    >
                  </div>
                </div>
                <p class="mb-0">1h ago</p>
              </div>
              <div
                class="listsys mb-3 d-flex justify-content-between align-items-start"
              >
                <div class="ltr">
                  <p class="themecolor medium">Rejected order</p>
                  <div class="d-flex align-items-center">
                    <span class="smallbtn greenBG mr-3">Urgent</span>
                    <span class="border_btn smallbtn themecolor mr-3"
                      >#CW225</span
                    >
                    <span class="messageChat d-flex align-items-center"
                      ><feather
                        class="mr-1"
                        size="18px"
                        type="message-circle"
                      ></feather>
                      3</span
                    >
                  </div>
                </div>
                <p class="mb-0">5h ago</p>
              </div>
            </div>
            <div class="openTabs" v-if="ticketsTab == 'closed'">
              <div
                class="listsys mb-3 d-flex justify-content-between align-items-start"
              >
                <div class="ltr">
                  <p class="themecolor medium">Cannot access the system</p>
                  <div class="d-flex align-items-center">
                    <span class="smallbtn textBG mr-3">Solved</span>
                    <span class="border_btn smallbtn themecolor mr-3"
                      >#CW225</span
                    >
                    <span class="messageChat d-flex align-items-center"
                      ><feather
                        class="mr-1"
                        size="18px"
                        type="message-circle"
                      ></feather>
                      5</span
                    >
                  </div>
                </div>
                <p class="mb-0">1h ago</p>
              </div>
              <div
                class="listsys mb-3 d-flex justify-content-between align-items-start"
              >
                <div class="ltr">
                  <p class="themecolor medium">Cancel my order</p>
                  <div class="d-flex align-items-center">
                    <span class="smallbtn textBG mr-3">Solved</span>
                    <span class="border_btn smallbtn themecolor mr-3"
                      >#CW225</span
                    >
                    <span class="messageChat d-flex align-items-center"
                      ><feather
                        class="mr-1"
                        size="18px"
                        type="message-circle"
                      ></feather>
                      2</span
                    >
                  </div>
                </div>
                <p class="mb-0">1h ago</p>
              </div>
              <div
                class="listsys mb-3 d-flex justify-content-between align-items-start"
              >
                <div class="ltr">
                  <p class="themecolor medium">Rejected order</p>
                  <div class="d-flex align-items-center">
                    <span class="smallbtn textBG mr-3">Solved</span>
                    <span class="border_btn smallbtn themecolor mr-3"
                      >#CW225</span
                    >
                    <span class="messageChat d-flex align-items-center"
                      ><feather
                        class="mr-1"
                        size="18px"
                        type="message-circle"
                      ></feather>
                      3</span
                    >
                  </div>
                </div>
                <p class="mb-0">5h ago</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="major_service_sec" class="outer_major_sersec">
        <ul
          class="inner_dropdown request_lisec mb-5"
          id="myUL"
          v-if="ticketReasonList != ''"
        >
          <li
            v-for="list in ticketData[-1]"
            v-if="
              parseInt(ticketReasonList[list].status) == 1 &&
              parseInt(ticketReasonList[list].tickets) == 1 &&
              list != '16'
            "
            class="effect-bubba"
          >
            <a
              href="javascript:void(0)"
              v-on:click="enableRequestElement(list)"
            >
              <div class="icon listWith">
                <img
                  :src="
                    '../../../../static/website/images/' + iconFile[list].icon
                  "
                  alt="Icon"
                />
              </div>
              <figcaption>
                <h6>{{ iconFile[list].lang }}</h6>
              </figcaption>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { supportMixins } from "@/plugins/support";
import profileRequest from "./services/profile_request";
export default {
  name: "SERVICES",
  mixins: [supportMixins],
  data() {
    return {
      pageTitle: this.$options.name,
      iconFile: {
        1: { icon: "sr_profile.svg", title: "Profile", lang: "Profile" },
        2: {
          icon: "sr_tradingaccount.svg",
          title: "Exchange",
          lang: "Exchange",
        },
        3: { icon: "otherTicket.svg", title: "PAMM Requests", lang: "" },
        4: { icon: "otherTicket.svg", title: "IB Requests", lang: "" },
        5: { icon: "sr_deposit.svg", title: "Deposits", lang: "Deposits" },
        6: {
          icon: "sr_withdrawals.svg",
          title: "Withdrawals",
          lang: "Withdrawals",
        },
        7: { icon: "sr_bonus.svg", title: "Bonus", lang: "" },
        8: { icon: "sr_vps.svg", title: "VPS", lang: "VPS" },
        9: { icon: "sr_reimbursement.svg", title: "Reimbursement", lang: "" },
        10: {
          icon: "sr_complaints.svg",
          title: "Complaints",
          lang: "Complaints",
        },
        11: { icon: "sr_compliance.svg", title: "Compliance", lang: "" },
        12: { icon: "sr_feedback.svg", title: "Feedback", lang: "Feedback" },
        13: { icon: "sr_others.svg", title: "Others", lang: "Others" },
        16: {
          icon: "sr_addpayment.svg",
          title: "Add Payment Method",
          lang: "Add payment method",
        },
        91: {
          icon: "otherTicket.svg",
          title: "Registeration Documents",
          lang: "",
        },
        92: { icon: "otherTicket.svg", title: "Skip Documents", lang: "" },
        94: { icon: "otherTicket.svg", title: "Become A Pro", lang: "" },
      },
      loadServiceRequest: "",
      serviceRequest: true,

      //come request from deposit----
      ticketRequestFrom: "",
      account_id: "",
      ticketsTab: "open",
      method_id: "",
      inList_custom_id: "",

      showDiv: "1",
      reason: "",
      reason_text: "",
      title: "0",
      title_text: "",
      info_req: "",
    };
  },
  components: {
    appProfile: profileRequest,
  },

  methods: {
    keymonitor() {
      var input, filter, ul, li, a, i, txtValue;
      input = document.getElementById("myInput");
      filter = input.value.toUpperCase();
      ul = document.getElementById("myUL");
      li = ul.getElementsByTagName("li");

      // Loop through all list items, and hide those who don't match the search query
      for (i = 0; i < li.length; i++) {
        a = li[i].getElementsByTagName("a")[0];

        txtValue = a.textContent || a.innerText;

        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          li[i].style.display = "";
        } else {
          li[i].style.display = "none";
        }
      }
    },
    enableRequestElement(elementName) {
      this.loadServiceRequest = elementName;
      if (
        !parseInt(
          this.ticketReasonList[this.loadServiceRequest].infomration_req
        ) ||
        (parseInt(this.loadServiceRequest) == 16 && this.method_id != "") ||
        (parseInt(this.loadServiceRequest) == 5 && this.method_id != "")
      ) {
        this.showDiv = "3";
        if (parseInt(this.loadServiceRequest) == 16) {
          this.chooseRequestType(
            this.inList_custom_id,
            this.ticketReasonList[this.loadServiceRequest]
          );
        } else if (parseInt(this.loadServiceRequest) == 5) {
          this.chooseRequestType(
            this.inList_custom_id,
            this.ticketReasonList[this.loadServiceRequest]
          );
        } else {
          this.chooseRequestType(
            "",
            this.ticketReasonList[this.loadServiceRequest]
          );
        }
      } else {
        this.showDiv = "1";
      }
      this.serviceRequest = false;
    },
    chooseRequestType(getInlistId, getOutListData) {
      // console.log(getInlistId)
      // console.log(getOutListData)
      this.reason = getOutListData.id;
      this.reason_text = getOutListData.title;
      this.title = "0";
      this.title_text = "";
      if (getInlistId != "" && getInlistId != null) {
        let count = 0;
        for (var key in this.ticketReasonList[this.loadServiceRequest]
          .categories) {
          count++;
          if (key == getInlistId) {
            this.title = key;
            this.title_text =
              this.ticketReasonList[this.loadServiceRequest].categories[
                key
              ].title;
            this.info_req =
              this.ticketReasonList[this.loadServiceRequest].categories[
                key
              ].infomration_req;
          }

          if (
            count ==
            Object.keys(
              this.ticketReasonList[this.loadServiceRequest].categories
            ).length
          ) {
            if (!parseInt(this.info_req)) {
              this.showDiv = "3";
            } else {
              this.showDiv = "2";
            }
          }
        }
      } else {
        this.showDiv = "3";
      }
    },
  },
  created() {
    if (parseInt(this.$route.params.ticketData) == 16) {
      this.method_id = this.$route.params.method_id;
      if (parseInt(this.method_id) == 1) {
        this.inList_custom_id = 93;
      }
      this.enableRequestElement(16);
    } else if (parseInt(this.$route.params.ticketData) == 5) {
      this.ticketRequestFrom = this.$route.params.page;
      this.method_id = this.$route.params.method_id;
      if (parseInt(this.method_id) == 69) {
        this.inList_custom_id = 69;
      }
      this.enableRequestElement(5);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/supports/request_services.vue